export default [
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'lei-aeronauta-parametros-legais',
		routerPath: '/lei-aeronauta-parametros-legais',
		componentName: 'LeiAeronautaParametrosLegais',
		componentPath: 'modules/layout/lei-aeronauta/parametros-legais/main'
	},
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'lei-aeronauta-horas-voadas',
		routerPath: '/lei-aeronauta-horas-voadas',
		componentName: 'LeiAeronautaHorasVoadas',
		componentPath: 'modules/layout/lei-aeronauta/horas-voadas/main'
	},
	{
		modulo: 23,
		privilegio: 24,
		routerName: 'lei-aeronauta-jornada-trabalho',
		routerPath: '/lei-aeronauta-jornada-trabalho',
		componentName: 'LeiAeronautaJornadaTrabalho',
		componentPath: 'modules/layout/lei-aeronauta/jornada-trabalho/main'
	}
]
